const urlWrapper = (route: string) => `${process.env.REACT_APP_URL_HOST}${route}`;
export default urlWrapper;
